module.exports = __webpack_public_path__ + "img/work.2a2f8f4d.svg";